import { render, staticRenderFns } from "./BannerReg.vue?vue&type=template&id=24cab287&scoped=true"
import script from "./BannerReg.vue?vue&type=script&lang=js"
export * from "./BannerReg.vue?vue&type=script&lang=js"
import style0 from "./BannerReg.vue?vue&type=style&index=0&id=24cab287&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cab287",
  null
  
)

export default component.exports